import { ChainName } from './name'

export const CHAIN_NATIVE_TOKEN = {
  [ChainName.ETHEREUM]: 'ETH',
  [ChainName.BASE]: 'BASE',
  [ChainName.ARC]: 'ARC'
}
